export const APPLE_APP_URL='https://apps.apple.com/br/app/cotaja/id6753153412';
export const GOOGLE_PLAY_URL='https://play.google.com/store/apps/details?id=com.cotaja_rn';
